import React, { Fragment } from "react";
import { ImageProperty } from "./imageGallery";

interface ImageCardProps extends ImageProperty {
  showImageDetails: (imagedata: ImageProperty) => void;
}

const ImageCard = (props: ImageCardProps) => {
  const handleShowImageDetails = () => {
    props.showImageDetails(props);
  };

  return (
    <Fragment>
      <li
        className="relative"
        onClick={() => {
          handleShowImageDetails();
        }}
      >
        <div className="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden h-20 cursor-pointer">
          <img
            src={props.imageUrl}
            alt={props.imageName}
            className="object-cover pointer-events-none group-hover:opacity-75"
          />
          <button type="button" className="absolute inset-0 focus:outline-none">
            <span className="sr-only">View details for IMG_4985.HEIC</span>
          </button>
        </div>
        <p className="mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none">
          {props.imageName}
        </p>
      </li>
    </Fragment>
  );
};

export default ImageCard;
